/* eslint-disable */
import React from 'react';
import Cross from 'static/icons/cross.svg';

export default ({ closeToast }) => <Cross onClick={closeToast} />;
